import { render, staticRenderFns } from "./DiscordTechDesign.vue?vue&type=template&id=3f119a5e&scoped=true"
import script from "./DiscordTechDesign.vue?vue&type=script&lang=js"
export * from "./DiscordTechDesign.vue?vue&type=script&lang=js"
import style0 from "./DiscordTechDesign.vue?vue&type=style&index=0&id=3f119a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f119a5e",
  null
  
)

export default component.exports